import CascateList from "../../../../../../common/components/cascate_list";
import PrimaryButton from "../../../../../../common/components/primary_button";
import { DefaultDateRangePickerInput } from "../../../../../../common/components/default_date_range_picker_input";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import { DropDown } from "../../../../../../common/domain/models/dropdown";
import { DefaultMultiAutocomplete } from "../../../../../../common/components/default_multi_autocomplete";


type Props = {
  ddlCentroCusto: DropDown[];
  ddlProjeto: DropDown[];
  ddlSolicitante: DropDown[];
  idsCentroCusto?: number[];
  idsProjeto?: number[];
  statusOptions?: DropDown[];
  idsSolicitante?: number[];
  status?: number[];

  dataDe?: Date | null;
  dataAte?: Date | null;

  onCentroCustoChange: (v: number[]) => void;
  onProjetoChange: (v: number[]) => void;
  onSolicitanteChange: (v: number[]) => void;
  onStatusChange: (v: number[]) => void;
  onDataChange: (de: Date | null, ate: Date | null) => void;

  onClearFilters: () => void;
};


export const Header = ({
  ddlCentroCusto,
  ddlProjeto,
  ddlSolicitante,
  idsCentroCusto,
  idsProjeto,
  idsSolicitante,
  statusOptions,
  status,
  dataDe,
  dataAte,
  onCentroCustoChange,
  onProjetoChange,
  onSolicitanteChange,
  onStatusChange,
  onDataChange,
  onClearFilters,
}: Props) => {

  return (
    <CascateList title="Pesquisar" defaultOpen>
      <div className="w-full p-6 flex flex-col gap-6">
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">
          <DefaultMultiAutocomplete
            label="Centro de Custo"
            options={ddlCentroCusto}
            value={ddlCentroCusto.filter((i) => idsCentroCusto?.includes(i.id))}
            getOptionLabel={(x) => x.title}
            getOptionKey={(x) => x.id}
            onChange={(x) => onCentroCustoChange(x?.map(y => y.id) ?? [])}
          />

          <DefaultMultiAutocomplete
            label="Projetos"
            options={ddlProjeto}
            value={ddlProjeto.filter((i) => idsProjeto?.includes(i.id))}
            getOptionLabel={(x) => x.title}
            getOptionKey={(x) => x.id}
            onChange={(x) => onProjetoChange(x?.map(y => y.id) ?? [])}
          />

          <DefaultMultiAutocomplete
            label="Solicitante"
            options={ddlSolicitante}
            value={ddlSolicitante.filter((i) => idsSolicitante?.includes(i.id))}
            getOptionLabel={(x) => x.title}
            getOptionKey={(x) => x.id}
            onChange={(x) => onSolicitanteChange(x?.map(y => y.id) ?? [])}
          />

          <DefaultMultiAutocomplete
            label="Status"
            options={statusOptions ?? []}
            value={statusOptions?.filter((x) => status?.includes(x.id)) ?? []}
            getOptionLabel={(x) => x.title}
            getOptionKey={(x) => x.id}
            onChange={(x) => onStatusChange(x?.map(y => y.id) ?? [])}
          />

          <DefaultDateRangePickerInput
            label="Data Solicitação"
            dataDe={dataDe ?? null}
            dataAte={dataAte ?? null}
            onChange={(start, end) => onDataChange(start, end)}
          />

        </div>

        <div className="flex justify-end">
          <div className="w-[180px]">
            <PrimaryButton
              startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
              buttonColor="yellow"
              onClick={() => onClearFilters()}>

              Limpar filtros
            </PrimaryButton>
          </div>
        </div>
      </div>
    </CascateList>
  );
};
